<template>
  <div class="verify-list-container">
    <div class="title">请确认投保地块信息</div>

    <div class="list-wrapper">
      <common-table
        class="table-wrapper"
        :columns="columns"
        :data="hadSelectedLandList"
        is-scroll
      >
        <template v-slot:crop="{ row }">
          <img class="crop-img" :src="row.coCropVO.imgUrl" alt="" />
          <span class="crop-name">{{ row.coCropGroupVO.cropGroupName }}</span>
        </template>

        <template v-slot:plantingLand="{ row }">
          <p>
            {{ row.coLandVO.landName }}
            <span class="unit"
              >（{{ row.coLandVO.statisticsLandAcre }}亩）</span
            >
          </p>
        </template>

        <template v-slot:plantingTime="{ row }">
          <p>{{ formatTime(row.coPlantPlanAgriVO.plantStartDate) }}</p>
        </template>

        <template v-slot:insureStartDate="{ row }">
          <p>{{ formatTime(row.insureStartDate) }}</p>
        </template>

        <template v-slot:insureEndDate="{ row }">
          <p>{{ formatTime(row.insureEndDate) }}</p>
        </template>

        <template v-slot:action="{ row }">
          <span class="cancel-select" @click="cancelSelect(row.landId)"
            >取消选择</span
          >
        </template>
      </common-table>
    </div>
    <div class="footer-action-box">
      <el-button class="prev btn" @click="clickPrevStep">上一步</el-button>
      <el-button
        class="next btn"
        type="primary"
        @click="clickNextStep"
        :loading="btnLoading"
        >下一步</el-button
      >
    </div>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable";
import { formatDate } from "@/utils";
import { mapGetters, mapState } from "vuex";
import { getInsureDetail } from "@/api/request/snkd.produce";
export default {
  components: { CommonTable },
  data() {
    return {
      btnLoading: false,
      columns: [
        {
          title: "作物",
          slot: "crop",
          className: "crop-col",
        },
        {
          title: "种植地块",
          slot: "plantingLand",
          className: "planting-land",
        },
        {
          title: "种植时间",
          slot: "plantingTime",
          className: "planting-time",
        },
        {
          title: "起保时间",
          slot: "insureStartDate",
          className: "start-time",
        },
        {
          title: "终保时间",
          slot: "insureEndDate",
          className: "end-time",
        },
        {
          title: "操作",
          slot: "action",
          colStyle: {
            flex: 1,
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("insure", ["hadSelectedLandList"]),
    ...mapState("insure", ["insureId"]),
    totalAcre() {
      return this.calcLandAcre(this.hadSelectedLandList);
    },
  },
  methods: {
    calcLandAcre(list) {
      const countStr = list
        .reduce((total, cur) => total + cur.coLandVO.statisticsLandAcre, 0)
        .toFixed(2);
      return parseFloat(countStr);
    },
    // 取消选择
    cancelSelect(landId) {
      if (this.hadSelectedLandList.length === 1) {
        this.$message({
          message: "至少选择1个地块",
          type: "warning",
        });
        return;
      }
      this.$store.commit("insure/changeSelectStatus", landId);
    },
    // 格式化时间
    formatTime(t) {
      return formatDate(t, "yyyy-MM-dd");
    },
    clickPrevStep() {
      this.$emit("prev-step", "ChooseLand");
    },
    async clickNextStep() {
      this.btnLoading = true;
      const res = await getInsureDetail({ id: 1 });
      this.btnLoading = false;
      //console.log("校验最小面积：", res);
      if (res.respCode == 0) {
        const minInsureLandAcre = res.obj.minInsureLandAcre;
        if (this.totalAcre > minInsureLandAcre) {
          this.$emit("next-step", "Form");
        } else {
          this.$message({
            message: "投保面积不小于" + minInsureLandAcre + "亩",
            type: "warning",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.verify-list-container {
  position: relative;
  height: 100%;
  background: #ffffff;
  .title {
    font-weight: 600;
    font-size: 22px;
    color: #333333;
    text-align: center;
    padding: 42px 0 12px;
  }
  .list-wrapper {
    height: calc(100% - 84px - 67px);
    margin: 0 30px;
    .table-wrapper {
      height: 100%;
    }
    .cancel-select {
      cursor: pointer;
      color: $--color-primary;
    }
  }
  .footer-action-box {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 67px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.04);
    .btn {
      width: 122px;
      &.prev {
        margin-right: 14px;
        color: $--color-primary;
        border-color: $--color-primary;
      }
    }
  }
}
</style>
<style lang="scss">
.list-wrapper {
  .crop-col {
    width: 289px;
    box-sizing: border-box;
    padding-left: 25px;
    .crop-img {
      width: 48px;
      height: 48px;
      margin-right: 16px;
    }
  }
  .planting-land {
    width: 303px;
    box-sizing: border-box;
    padding-left: 25px;
    line-height: 20px;
    .unit {
      color: #cccccc;
    }
  }
  .planting-time {
    width: 146px;
    box-sizing: border-box;
    padding-left: 25px;
  }
  .start-time {
    width: 144px;
    box-sizing: border-box;
    padding-left: 25px;
  }
  .end-time {
    width: 150px;
    box-sizing: border-box;
    padding-left: 25px;
  }
}
</style>
